import { useMemo } from 'react';
import ModalSlider from '../modal-slider/modal-slider';
import BPMS_Collab from '../../../assets/onboarding/2.2/BPMS_Collab.gif';
import BPMS_Drag from '../../../assets/onboarding/2.2/BPMS_Drag.gif';
import BPMS_FindRemixes from '../../../assets/onboarding/2.2/BPMS_FindRemixes.gif';
import BPMS_Q2_ArtistProfiles from '../../../assets/onboarding/2.2/BPMS_Q2_ArtistProfiles.png';
import BPMS_Q2_Notifs from '../../../assets/onboarding/2.2/BPMS_Q2_Notifs.png';

export function BPMSupremeQ22Update() {
    const data = useMemo(
        () => [
            {
                image: BPMS_FindRemixes,
                title: 'Find Remixes',
                text: 'You can now locate all remixes of a track with one click. This is especially helpful for finding exclusive versions that can make your DJ set stand out.'
            },
            {
                image: BPMS_Collab,
                title: 'Collaborative Playlists',
                text: 'DJs with a Premium subscription can now add collaborators to a custom playlist to add tracks, share playlists, and upload custom artwork.'
            },
            {
                image: BPMS_Q2_Notifs,
                title: 'Notification Updates',
                text: 'Notifications are now more informative and include clickable actions to help you find what you’re looking for faster.'
            },
            {
                image: BPMS_Drag,
                title: 'Drag and Drop + Sidebar Improvements',
                text: 'DJs can now drag and drop a track into a custom playlist or the crate for download. They can also reorder playlists or their queue by dragging and dropping, and select multiple songs to drag and drop to a new folder or playlist.'
            },
            {
                image: BPMS_Q2_ArtistProfiles,
                title: 'Song Type on Artist Profiles',
                text: 'You can now filter the songs on an artists’ profile by originals and remixes, making it easier to find what you’re looking for.'
            }
        ],
        []
    );

    return <ModalSlider title="BPM Supreme 2.2 Update" type="BPMSupremeQ22Update" sliderItems={data} />;
}

export default BPMSupremeQ22Update;
